import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=718404e4&scoped=true&"
import script from "./journal.vue?vue&type=script&lang=js&"
export * from "./journal.vue?vue&type=script&lang=js&"
import style0 from "./journal.vue?vue&type=style&index=0&id=718404e4&lang=less&scoped=true&"
import style1 from "./journal.vue?vue&type=style&index=1&id=718404e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718404e4",
  null
  
)

export default component.exports